"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getODSPItemDetailById = exports.getDriveItemInfo = exports.encodeSharePointUrl = exports.getSharePointSiteByRelativePath = exports.createGraphClientWithToken = void 0;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const constants_1 = require("../../../common/constants");
const axios_1 = tslib_1.__importDefault(require("axios"));
const constant_1 = require("../constant");
/**
 * Create a graph client with token
 * @param context The context
 * @returns The graph client
 */
async function createGraphClientWithToken(context) {
    var _a;
    const graphTokenRes = await ((_a = context.tokenProvider) === null || _a === void 0 ? void 0 : _a.m365TokenProvider.getAccessToken({
        scopes: constants_1.GraphScopes,
    }));
    if (!(graphTokenRes === null || graphTokenRes === void 0 ? void 0 : graphTokenRes.isOk())) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.SystemError({
            source: "copilotPlugin",
            name: "GetGraphTokenFailed",
            message: "Failed to get Graph token",
            displayMessage: "Failed to get Graph token",
        }));
    }
    const client = axios_1.default.create({
        baseURL: "https://graph.microsoft.com/v1.0",
        headers: { Authorization: `Bearer ${graphTokenRes.value}` },
    });
    return (0, teamsfx_api_1.ok)(client);
}
exports.createGraphClientWithToken = createGraphClientWithToken;
/**
 * Get the SharePoint site by relative path
 * @param graphClient The graph client
 * @param url The share point url
 * @returns The SharePoint site
 */
async function getSharePointSiteByRelativePath(graphClient, url) {
    // Extract the hostname and relative path from the url
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    const relativePath = urlObj.pathname;
    try {
        const res = await graphClient.get(`/sites/${hostname}:${relativePath}?$select=id,name,sharepointIds`);
        return (0, teamsfx_api_1.ok)({
            id: res.data.id,
            name: res.data.name,
            webId: res.data.sharepointIds.webId,
            siteId: res.data.sharepointIds.siteId,
        });
    }
    catch (error) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError({
            source: "copilotPlugin",
            name: "GetSharePointSiteFailed",
            message: "Failed to get SharePoint site",
            displayMessage: "Failed to get SharePoint site",
        }));
    }
}
exports.getSharePointSiteByRelativePath = getSharePointSiteByRelativePath;
/**
 * Encode the share point url
 * @param itemUrl The share point url
 * @returns The encoded url
 */
function encodeSharePointUrl(itemUrl) {
    const base64Value = Buffer.from(itemUrl).toString("base64");
    return "u!" + base64Value.replace(/=+$/, "").replace(/\//g, "_").replace(/\+/g, "-");
}
exports.encodeSharePointUrl = encodeSharePointUrl;
/**
 * Get the drive item info
 * @param graphClient The graph client
 * @param encodedUrl The encoded url
 * @returns The drive item info
 */
async function getDriveItemInfo(graphClient, encodedUrl) {
    const res = await graphClient.get(`/shares/${encodedUrl}/driveItem?$select=id,name,sharepointIds,webUrl,file,folder`);
    return {
        id: res.data.id,
        name: res.data.name,
        uniqueId: res.data.sharepointIds.listItemUniqueId,
        listId: res.data.sharepointIds.listId,
        webId: res.data.sharepointIds.webId,
        siteId: res.data.sharepointIds.siteId,
        webUrl: res.data.webUrl,
        itemType: res.data.file ? constant_1.OneDriveSharePointItemType.File : constant_1.OneDriveSharePointItemType.Folder,
    };
}
exports.getDriveItemInfo = getDriveItemInfo;
async function getODSPItemDetailById(context, siteId, itemId) {
    const graphClientResult = await createGraphClientWithToken(context);
    if (graphClientResult.isErr()) {
        return (0, teamsfx_api_1.err)(graphClientResult.error);
    }
    const graphClient = graphClientResult.value;
    try {
        const itemRes = await graphClient.get(`/sites/${siteId}/drive/items/${itemId}`);
        return (0, teamsfx_api_1.ok)([
            {
                id: itemRes.data.id,
                name: itemRes.data.name,
                url: itemRes.data.webUrl,
            },
        ]);
    }
    catch (error) {
        if (axios_1.default.isAxiosError(error) && error.response) {
            if (error.response.status >= 400 && error.response.status < 510) {
                return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("getODSPItemDetailById", "GraphApiError", error.response.data.error.message, error.response.data.error.message));
            }
        }
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.SystemError("getODSPItemDetailById", "GraphApiError", error.message, error.message));
    }
}
exports.getODSPItemDetailById = getODSPItemDetailById;
//# sourceMappingURL=oneDriveSharePointHandler.js.map